// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
import { DirectMessageBase } from './DirectMessageBase.ts'
import { ReportMessageImportanceLevel } from '../../Utils/Enums/Constants.js'
import { DirectMessageCode } from './DirectMessageCodes.ts';

export let DirectReportMessage = function (name, data, rawMessage)
{
    // TODO. ReportMessage: XMLMessage
    DirectMessageBase.call(this, DirectMessageCode.CODE_XML_REPORT);

    this.Name = name;
    this.Data = data;
    this.RawMessage = rawMessage;
    this.Roundtrip = 0;
    this.Instrument = null;
    this.ImportanceLevel = ReportMessageImportanceLevel.Normal;
    // TODO. UGLY. Refactor. Remove when BusinessRejectMessage is treated correctly.
    this.reject = false;

    this.SkipOnTicketViewer = false;
};
DirectReportMessage.prototype = Object.create(DirectMessageBase.prototype);